
export const bankDetails = {
    bank1: {
        name: "UAE Bank Account", // Used only for the tab label
        details: {
            "Beneficiary Name": "GAEL LUXURY HOMES RENTAL L.L.C",
            "IBAN": "AE490860000009656605850",
            "Account Number": "9656605850",
            "SWIFT / BIC Code": "WIOBAEADXXX",
            "Currency": "AED",
            "Bank Country": "United Arab Emirates",
            "Bank Name": "WIO BANK P.J.S.C.",
            "Bank Address": "Etihad Airways Centre 5th Floor, Abu Dhabi, UAE",

        },
    },
    

    // Add more bank objects as needed
};
